
import routes from '../../utils/routes';

const getNavList = (appNav) => {

  const check = (key) => () => {
    if(appNav?.[key]) {
      return true
    } 
    return false
  }


  const navList = [
    {
      title: "About us",
      path: routes.about,
      isDropdown: false,
      check: check('about'),

      
    },
    {
      title: "Updates",
      path: routes.news,
      isDropdown: false,
      check: check('news'),
    },
    {
      title: "Countries",
      path: routes.countries,
      isDropdown: true,
      check: check('country')
    },
    {
      title: "Resources",
      path: routes.resources,
      isDropdown: false,
      check: check('resource'),
      

    },
    {
      title: "Share your story",
      path: routes.share,
      isDropdown: false,
      check: check('story')
    },
    {
      title: "Feedback",
      path: routes.feedback,
      isDropdown: false,
      check: check('feedback')
    },
  ];


return navList;
}

export const blogMenu = [
  {
      title: 'Featured',
      path: routes.news,
  },
  {
      title: 'Countries',
      path: '#',
      isDropdown: true,
  }, {
      title: 'News',
      path: routes.blogs.replace(':id', 'news'),
  }, {
      title: 'Blog',
      path: routes.blogs.replace(':id', 'blog'),
      active: true
  },
];


export default getNavList;

